var map = {
	"./Academy/assets/images/module-academy.svg": "5228",
	"./Actionsboard/assets/images/actions.svg": "bbd7",
	"./Actionsboard/assets/images/fasts.svg": "30b1",
	"./Marketplace/assets/images/module.svg": "d7c5",
	"./Orgchart/assets/images/module.svg": "17ff",
	"./Process/assets/images/form.svg": "04fc",
	"./Process/assets/images/process.svg": "4600",
	"./Quest/assets/images/module.svg": "ff94",
	"./Quest/assets/images/mq_1.svg": "56cb",
	"./Quest/assets/images/mq_2.svg": "cad1",
	"./Quest/assets/images/mq_3.svg": "478d",
	"./Quest/assets/images/mq_4.svg": "95ef",
	"./Quest/assets/images/mq_5.svg": "726e",
	"./Quest/assets/images/mq_bg.svg": "9d5b",
	"./Quest/assets/images/mq_start.svg": "8dd4",
	"./Quest/assets/images/pick_card.png": "66798",
	"./Saas/assets/images/kpi.svg": "7e94",
	"./Wiki/assets/images/module-onboarding.svg": "17ab",
	"./Wiki/assets/images/module-wiki.svg": "04cc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6dfe";